import { ChangeDetectorRef, Component, Inject, OnInit, effect} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule, SpinnerService } from 'merlin-library';
import { CommonService } from '../service/common.service';
import { LocalizationService } from 'src/core/utilitites/localization.service';

interface DeviceRow {
  deviceName: string;
}

@Component({
  selector: 'app-icmai-devices-dialog',
  templateUrl: './icmai-devices-dialog.component.html',
  styleUrls: ['./icmai-devices-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatTableModule, MatButtonModule, SharedModule]
})
export class IcmaiDevicesDialogComponent implements OnInit {
  displayedColumns = ['model','keyEpisodeSupported'];
  dataSource: any;
  isAISupportedClinic = false;
  isClinicLevel = false;
  customerId: number;
  patientId: string;

  public stringLabels = [
    'label.gb.device_list',
    'label.gb.model',
    'label.gb.KeyEpisode',
    'label.gb.AI_powered',
    'label.gb.close',
    'label.gb.KE_supported',
    'label.gb.KE_not_supported',
    'label.gb.AlwaysON',
    'label.gb.icm'
  ];
  public labels: Record<string, string> = {};
  public parsedHtml: Record<string, string> = {};
  headerVal: string = '';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private spinnerService: SpinnerService,
        private commonService: CommonService,
        private localizationService: LocalizationService,
        private cd: ChangeDetectorRef
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
            this.parsedHtml = this.localizationService.reparseLocalizedHtmlStrings(this.parsedHtml);
        });
        this.isClinicLevel = data?.isClinicLevel ?? false;
        this.customerId = data?.customerId ?? null;
        this.patientId = data?.patientId != null ? String(data.patientId) : null;

    }
  ngOnInit(): void {
    this.spinnerService.visibility = true;
    this.cd.detectChanges();
    this.translateStrings();
    this.getHeader();
    this.loadTableData();
  }

  private loadTableData() {
        if(this.isClinicLevel){
            this.commonService.getICMAIDevicesClinicLevel(this.customerId).subscribe((devices)=>{ 
                this.addTableColumns(devices);
        });
        } else {
            this.commonService.getICMAIDevicesPatientLevel(this.patientId).subscribe((devices)=>{
                this.addTableColumns(devices);
            });
        }
    }

  addTableColumns(devices) {
    this.dataSource = devices;
    if (this.dataSource.length
        !== 0 && this.dataSource[0]?.aiUnlocked) {
        if (!this.displayedColumns.includes('aiSupported')) {
          this.displayedColumns.push('aiSupported'); // add AI Supported column if AI is unlocked
        }
        this.isAISupportedClinic = true;

    }
    this.dataSource.forEach(device => {
        device['keyEpisodeSupported'] = device.keyEpisodeCapableFlg ? this.labels['label.gb.KE_supported'] : this.labels['label.gb.KE_not_supported'];
        if(this.isAISupportedClinic){
            device['aiSupported'] = device.aiCapableFlg ? this.labels['label.gb.AlwaysON'] : this.labels['label.gb.KE_not_supported'];
        }
    });
    // Sorts data source by model number
    this.dataSource = this.dataSource.sort((a, b) => {
      const numA = Number(a.model.split(" ")[0]);
      const numB = Number(b.model.split(" ")[0]);
      return numA - numB;
    });
    this.dataSource = new MatTableDataSource(this.dataSource); // Refresh data source
    this.spinnerService.visibility = false;
    this.cd.detectChanges();
  }

  getHeader() {
    this.headerVal = this.localizationService.generateLocalizedStr('msg.gb.ICM_devices_desc', {
        '0': this.labels['label.gb.icm']
    });
  }

  translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key);
  }

  translateStrings() {
    let stringsRecord = this.localizationService.loadLocalizedStrings(this.stringLabels);
    this.labels = { ...this.labels, ...stringsRecord };
  }
}
